module.exports = __webpack_public_path__ + "img/fensys.bb16dfbb.svg";